import { Component, EventEmitter, Output } from '@angular/core';

import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { AlertDataService } from 'src/app/main/shared/services/alert-data.service';
import { IAlert } from 'src/app/core/dto';

@Component({
  selector: 'fury-toolbar-quickpanel-toggle',
  templateUrl: './toolbar-quickpanel-toggle.component.html',
  styleUrls: ['./toolbar-quickpanel-toggle.component.scss'],
  imports: [FlexLayoutModule, MatTooltipModule, MatButtonModule],
})
export class ToolbarQuickpanelToggleComponent {
  @Output() openQuickPanel = new EventEmitter();
  alerts: IAlert[] = [];

  constructor(public alertService: AlertDataService) {}
}
